<template>
  <div class="section-wrapper">
    <div class="sec5-trigger"></div>
    <div class="left-side sec-5-left-side">
      <div class="left-side-inner">
        <img :src="imageUrl" alt="Zdjęcie magazynu Amica we Wronkach" />
      </div>
    </div>
    <div class="right-side sec-5-right-side">
      <div class="right-side-inner">
        <h2>Kompetencje poparte doświadczeniem</h2>
        <p>
          Jesteśmy największym producentem dużego AGD w Polsce, a nasze urządzenia obecne są aż w 55 krajach. Mamy ponad 60 lat doświadczenia. To pozwala nam codziennie być blisko naszych użytkowników, których opinia jest dla nas niezwykle ważna. Tworząc nowe generacje urządzeń zawsze bierzmy pod uwagę ich potrzeby i spostrzeżenia. Dzięki czemu udoskonalamy nasze produkty, by były jeszcze bardziej użyteczne i pomocne każdego dnia.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    imageUrl: function () {
      return window.pageContentData.params.images['img-sec-2']
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-wrapper {
    width: 100%;
    height: auto;
    position: relative;
    align-items: center;
    padding: 4rem 0 4rem;
    display: flex;
    background: #fff;
    z-index: 2;

    @media only screen and (max-width : 1024px) {
      min-height: auto;
      height: auto;
      padding: 4rem 0;
    }

    @media only screen and (max-width : 768px) {
      flex-direction: column;
      padding: 2rem 0;
    }

    .left-side {
      height: 100%;
      width: 58.33vw;

      @media only screen and (max-width : 768px) {
        width: 100%;
      }

      .left-side-inner {
        padding-left: 8.3333vw;

        @media only screen and (max-width : 768px) {
          padding-left: 0px;
          // padding-right: 8.33%;
        }

        img {
          width: 100%;
          max-width: 100%;

          @media only screen and (max-width : 768px) {
            margin-bottom: 2rem;
          }
        }
      }
    }

    .right-side {
      height: 100%;
      width: 50%;
      position: relative;

      @media only screen and (max-width : 768px) {
        width: 100%;
      }

      .right-side-inner {
        padding-left: 8.33vw;
        width: 33.32vw;
        height: 100%;
        box-sizing: content-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        @media only screen and (max-width : 768px) {
          padding-left: 8.33%;
          padding-right: 8.33%;
          width: calc(100% - 8.33% - 8.33%);
        }

        h2 {
          color: #e41429;
          font-size: 3.2rem;
          margin-bottom: 2rem;
          font-weight: 600;
          margin-top: auto;
          width: 80%;

          @media only screen and (max-width : 1024px) {
            font-size: 2.2rem;
          }
        }

        p {
          margin-bottom: auto;
          width: 80%;

          @media only screen and (max-width : 768px) {
            width: 100%;
          }
        }

      }
    }
  }
</style>
